export const Questions = [
	{
		prompt:
			'Evaluate the following expressions. \n (1). 27 + -5 \n (2). -18 + -20 - 16 \n (3). -15 - -7',
		optionA: '-22, 54, 8',
		optionB: '32, 16, 22',
		optionC: '22, -54, -8',
		optionD: '+22, +54, -7',
		asnwer: 'optionC',
	},
	{
		prompt:
			'Evaluate the following algebraic expressions when a = 3, z = -8 \n (1). 4a + z ',
		optionA: '+4',
		optionB: '-1',
		optionC: '-4',
		optionD: '2',
		asnwer: 'optionA',
	},
	{
		prompt: '20 % of 2 is equal to',
		optionA: '20',
		optionB: '4',
		optionC: '0.4',
		optionD: '0.04',
		asnwer: 'optionC',
	},
	{
		prompt:
			'Simplify the following expressions by combining like terms. \r\n 5a + 2a + 7a',
		optionA: '16a',
		optionB: '15a',
		optionC: '17a',
		optionD: '14a',
		asnwer: 'optionD',
	},
];
